import { createSelector } from 'reselect'

import slideTypes from 'helpers/enums/slideTypes'
import activityOriginSelector from 'redux/selectors/activity_creation/activity_origin_selector'
import presentationOriginTypes from 'helpers/enums/presentationOriginTypes'
import routeTypes from 'helpers/enums/routeTypes'

const cancelSlideUrl = (state, props) => {
	let slideData = {}

	switch (props.slideType) {
		case slideTypes.SLIDE_TYPE_ID_OPEN_ENDED_QUESTION:
			slideData = state.oeq
			break
		case slideTypes.SLIDE_TYPE_ID_DRAW_IT:
			slideData = state.drawIt
			break
		case slideTypes.SLIDE_TYPE_ID_QUIZ:
			slideData = state.quiz
			break
		case slideTypes.SLIDE_TYPE_ID_POLL:
			slideData = state.poll
			break
		case slideTypes.SLIDE_TYPE_ID_TIME_TO_CLIMB:
		case slideTypes.SLIDE_TYPE_ID_FLIPGRID:
		case slideTypes.SLIDE_TYPE_ID_VIDEO:
			slideData = state.qs
			break
		case slideTypes.SLIDE_TYPE_ID_MATCHING_PAIRS:
			slideData = state.matchingPairsCt
			break
		case slideTypes.SLIDE_TYPE_ID_FLOCABULARY:
			slideData = state.flocabulary
			break
		case slideTypes.SLIDE_TYPE_ID_GRAPHING_CALCULATOR:
			slideData = state.desmos
			break
	}

	return slideData.cancelUrl || ''
}

const cancelSlideSelector = createSelector(
	[ cancelSlideUrl, activityOriginSelector ],
	(cancelSlideUrlData, activityOrigin) => {
		let cancelUrl = ''

		if (activityOrigin === presentationOriginTypes.REGULAR) {
			cancelUrl = cancelSlideUrlData
		} else {
			cancelUrl = routeTypes.LIBRARY
		}

		return {
			cancelUrl,
		}
	}
)

export default cancelSlideSelector
